import { authActions, getStudentByID, getTeacherByEmail } from '../slices/userSlice/authSlice'
import request from '../../utils/request'
import { toast } from 'react-toastify'
import axios from 'axios'
import { deviceDetect } from 'react-device-detect'
import { redirect, useNavigate } from 'react-router-dom'
const publicIp = require('react-public-ip')

// Login User
export function loginUser(user) {
  return async (dispatch) => {
    try {
      let public_ipv4 = '';
      let deviceInfo = {};

      // 1. Safely gather audit info without blocking login
      try {
        public_ipv4 = (await publicIp.v4()) || '';
        deviceInfo = deviceDetect();
      } catch (auditError) {
        console.warn("Audit tracking failed:", auditError);
      }

      const res = await axios.post(
        `/students/auth`,
        { user, public_ipv4, deviceInfo },
        {
          baseURL: process.env.REACT_APP_API_URL,
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            // Removed Access-Control-Allow-Origin (it's for the server side)
          },
        }
      );

      if (res.status === 200) {
        localStorage.setItem('studentInfo', JSON.stringify(res.data));
        dispatch(authActions.login(res.data));

        if (res.data?.MATRICULE) {
          dispatch(getStudentByID({ MATRICULE: res.data.MATRICULE }));
        }
      } else {
        toast.error(res.data);
      }
    } catch (error) {
      // Use optional chaining to avoid "cannot read message of undefined"
      const errorMsg = error.response?.data?.message || "Erreur de connexion au serveur";
      toast.error(errorMsg);
    }
  };
}

export function loginUser1(user) {
  return async (dispatch) => {
    try {
      const public_ipv4 = (await publicIp.v4()) || ''

      const deviceInfo = deviceDetect()
      const res = await axios.post(
        `/students/auth`,
        { user, public_ipv4, deviceInfo },
        {
          baseURL: `${process.env.REACT_APP_API_URL}`,
          withCredentials: true,
          headers: {
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
            'Content-Type': 'application/json',
          },
        },
      )

      if (res.status == 200) {
        localStorage.setItem('studentInfo', JSON.stringify(res.data))
        dispatch(authActions.login(res.data))

        //dispatch(getStudentByID({ MATRICULE: user?.MATRICULE }))
        if (res.data?.MATRICULE) {
          dispatch(getStudentByID({ MATRICULE: res.data?.MATRICULE }))
        }
        //dispatch(getStudentByID({ MATRICULE: user?.username, type }))
      } else {
        toast.error(res.data)
      }
    } catch (error) {
      toast.error(error.response.data.message)
    }
  }
}

// Forgot Password
export function forgotPassword({ user, lang }) {
  return async (dispatch) => {
    try {
      await axios.post(
        `/students/forgot-password`,
        { user },
        {
          baseURL: process.env.REACT_APP_API_URL,
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            // Removed Access-Control-Allow-Origin
          },
        }
      );

      toast.success(
        lang === 'Français'
          ? "Veuillez consulter votre mail pour réinitialiser votre mot de passe"
          : "Please check your email to reset your password"
      );
    } catch (error) {
      // 1. Check if the server actually sent a response
      if (!error.response) {
        toast.error(
          lang === 'Français' 
            ? "Erreur de connexion au serveur" 
            : "Server connection error"
        );
        return;
      }

      // 2. Handle specific status codes safely
      const status = error.response.status;
      const data = error.response.data;

      switch (status) {
        case 401:
          toast.error(data.message);
          break;
        case 400:
          toast.error(
            lang === 'Français'
              ? "Erreur ! Il n'y a aucun étudiant avec ce matricule"
              : "Error! No student found with this identification number"
          );
          break;
        case 404:
          toast.error(
            lang === 'Français'
              ? "Erreur ! L'email n'a pas pu être envoyé"
              : "Error! The email could not be sent"
          );
          break;
        default:
          toast.error(data.message || "An unexpected error occurred");
      }
    }
  };
}

export function forgotPassword1({ user, lang }) {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `/students/forgot-password`,
        { user },
        {
          baseURL: `${process.env.REACT_APP_API_URL}`,
          withCredentials: true,
          headers: {
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
            'Content-Type': 'application/json',
          },
        },
      )
      toast.success(
        lang === 'Français'
          ? `Veuillez consulter votre mail pour réinitialiser votre mot de passe`
          : `Please check your email to reset your password`,
      )
    } catch (error) {
      //console.log(error)
      switch (error.response.status) {
        case 401:
          toast.error(error.response.data.message)
          break
        case 400:
          toast.error(
            lang === 'Français'
              ? `Erreur ! Il n'y a aucun étudiant avec ce matricule`
              : 'Error ! There are no students with this identification number',
          )
          break
        case 404:
          toast.error(
            lang === 'Français'
              ? `Erreur ! L'email n'a pas pu être envoyé`
              : `Error ! The email could not be sent`,
          )
          break
      }
      //toast.error(error.response.data.message)
    }
  }
}

// Request account
export function requestAccount({ user, lang }) {
  return async (dispatch) => {
    try {
      await axios.post(
        `/students/request-account`,
        { user },
        {
          baseURL: process.env.REACT_APP_API_URL,
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            // Cleaned: Removed 'Access-Control-Allow-Origin' client-side
          },
        }
      );

      toast.success(
        lang === 'Français'
          ? "Veuillez consulter votre mail pour activer votre compte"
          : "Please check your email to activate your account"
      );
    } catch (error) {
      // 1. Guard against network/server-down errors
      if (!error.response) {
        toast.error(
          lang === 'Français' 
            ? "Erreur de connexion au serveur" 
            : "Server connection error"
        );
        return;
      }

      const { status, data } = error.response;

      // 2. Bilingual Error Handling
      switch (status) {
        case 400:
          toast.error(
            lang === 'Français'
              ? "Erreur ! Il n'y a aucun étudiant avec ce matricule"
              : "Error! No student found with this identification number"
          );
          break;
        case 401:
          toast.error(data.message || "Unauthorized");
          break;
        case 404:
          toast.error(
            lang === 'Français'
              ? "Erreur ! L'email n'a pas pu être envoyé"
              : "Error! The email could not be sent"
          );
          break;
        case 405:
          toast.error(
            lang === 'Français'
              ? "Votre compte est déjà activé. Réinitialisez votre mot de passe !"
              : "Your account is already activated. Reset your password!"
          );
          break;
        default:
          toast.error(data.message || "Internal Server Error");
      }
    }
  };
}

export function requestAccount1({ user, lang }) {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `/students/request-account`,
        { user },
        {
          baseURL: `${process.env.REACT_APP_API_URL}`,
          withCredentials: true,
          headers: {
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
            'Content-Type': 'application/json',
          },
        },
      )
      toast.success(
        lang === 'Français'
          ? `Veuillez consulter votre mail pour activer votre compte`
          : `Please check your email to activate your account`,
      )
    } catch (error) {
      //console.log(error)
      switch (error.response.status) {
        case 401:
          toast.error(error.response.data.message)
          break
        case 400:
          toast.error(
            lang === 'Français'
              ? `Erreur ! Il n'y a aucun étudiant avec ce matricule`
              : 'Error ! There are no students with this identification number',
          )
          break
        case 404:
          toast.error(
            lang === 'Français'
              ? `Erreur ! L'email n'a pas pu être envoyé`
              : `Error ! The email could not be sent`,
          )
          break
        case 405:
          toast.error(
            lang === 'Français'
              ? `Votre compte est déjà activé. Réinitialisez votre mot de passe !`
              : `Your account is already activated. Reset your password !`,
          )
          break
      }
      //toast.error(error.response.data.message)
    }
  }
}

// Reset Password
export function resetPassword({ MATRICULE, password, token, lang }) {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `/students/reset-password`,
        { MATRICULE, password, token },
        {
          baseURL: process.env.REACT_APP_API_URL,
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            // Cleaned: Removed client-side Access-Control-Allow-Origin
          },
        }
      );

      toast.success(
        lang === 'Français'
          ? "Votre mot de passe a été réinitialisé avec succès"
          : "Your password has been successfully reset"
      );
      
      return res.status;
    } catch (error) {
      if (!error.response) {
        toast.error(lang === 'Français' ? "Erreur de connexion" : "Connection error");
        return 500;
      }

      const { status, data } = error.response;

      switch (status) {
        case 400:
          toast.error(
            lang === 'Français'
              ? "Erreur ! Il n'y a aucun étudiant avec ce matricule"
              : "Error! No student found with this identification number"
          );
          break;
        case 401:
        case 403:
          // 403 usually indicates an expired or invalid token
          toast.error(
            lang === 'Français'
              ? "Lien invalide ou expiré. Veuillez recommencer la procédure."
              : "Invalid or expired link. Please restart the process."
          );
          break;
        default:
          toast.error(data.message || "Error");
      }
      return status;
    }
  };
}

export function resetPassword1({ MATRICULE, password, token, lang }) {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `/students/reset-password`,
        { MATRICULE, password, token },
        {
          baseURL: `${process.env.REACT_APP_API_URL}`,
          withCredentials: true,
          headers: {
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
            'Content-Type': 'application/json',
          },
        },
      )
      toast.success(
        lang === 'Français'
          ? `Votre mot de passe a été réinitialisé avec succès`
          : `Your password has been successfully reset`,
      )
      //return navigate('/')
      return res.status
    } catch (error) {
      //console.log(error)
      switch (error.response.status) {
        case 401:
        case 403:
          toast.error(
            lang === 'Français'
              ? `Erreur de réinitialisation de mot de passe`
              : 'Password reset error',
          )
          break
        case 400:
          toast.error(
            lang === 'Français'
              ? `Erreur ! Il n'y a aucun étudiant avec ce matricule`
              : 'Error ! There are no students with this identification number',
          )
          break
        case 401:
          toast.error(error.response.data.message)
          break
      }
      //toast.error(error.response.data.message)
      return error.response.status
    }
  }
}

// Reset Password
export function activateAccount({ MATRICULE, password, token, lang }) {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `/students/activate-account`,
        { MATRICULE, password, token },
        {
          baseURL: process.env.REACT_APP_API_URL,
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            // Removed client-side Access-Control-Allow-Origin
          },
        }
      );

      toast.success(
        lang === 'Français'
          ? "Votre compte a été activé avec succès"
          : "Your account has been successfully activated"
      );

      return res.status;
    } catch (error) {
      // 1. Safe guard against undefined response (server down/timeout)
      if (!error.response) {
        toast.error(
          lang === 'Français' 
            ? "Erreur de connexion au serveur" 
            : "Server connection error"
        );
        return 500;
      }

      const { status, data } = error.response;

      switch (status) {
        case 400:
          toast.error(
            lang === 'Français'
              ? "Erreur ! Il n'y a aucun étudiant avec ce matricule"
              : "Error! No student found with this identification number"
          );
          break;
        case 401:
        case 403:
          // Handles cases where the activation token is wrong or expired
          toast.error(
            lang === 'Français'
              ? "Lien d'activation invalide ou expiré"
              : "Invalid or expired activation link"
          );
          break;
        default:
          toast.error(data.message || "Error");
      }
      
      return status;
    }
  };
}

export function activateAccount1({ MATRICULE, password, token, lang }) {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `/students/activate-account`,
        { MATRICULE, password, token },
        {
          baseURL: `${process.env.REACT_APP_API_URL}`,
          withCredentials: true,
          headers: {
            'Access-Control-Allow-Origin': `${process.env.REACT_APP_API_URL}`,
            'Content-Type': 'application/json',
          },
        },
      )
      toast.success(
        lang === 'Français'
          ? `Votre compte a été activé avec succès`
          : `Your account has been successfully activated`,
      )
      //return navigate('/')
      return res.status
    } catch (error) {
      //console.log(error)
      switch (error.response.status) {
        case 401:
        case 403:
          toast.error(
            lang === 'Français'
              ? `Erreur d'activation de votre compte`
              : 'Error activating your account',
          )
          break
        case 400:
          toast.error(
            lang === 'Français'
              ? `Erreur ! Il n'y a aucun étudiant avec ce matricule`
              : 'Error ! There are no students with this identification number',
          )
          break
        case 401:
          toast.error(error.response.data.message)
          break
      }
      //toast.error(error.response.data.message)
      return error.response.status
    }
  }
}

// Logout User
export function logoutUser() {
  return async (dispatch) => {
    try {
      // 1. Optional: Call the backend to clear the session cookie
      // await axios.post(`${process.env.REACT_APP_API_URL}/students/logout`, {}, { withCredentials: true });

      // 2. Clear Redux state
      dispatch(authActions.logout());

      // 3. Clear local persistence
      localStorage.removeItem('studentInfo');
      
      // Optional: Clear any other cached student data
      // localStorage.removeItem('userYear');

      // Success toast (Optional)
      // toast.info(lang === 'Français' ? "Déconnecté" : "Logged out");

    } catch (error) {
      // Only needed if you call an API
      const errorMsg = error.response?.data?.message || "Error during logout";
      toast.error(errorMsg);
    }
  };
}

export function logoutUser1() {
  return async (dispatch) => {
    try {
      //const res = await axios.post(`/users/logout`)
      //if (res.status == 200) {
      dispatch(authActions.logout())
      localStorage.removeItem('studentInfo')
      //localStorage.removeItem('userYear')
      //}
    } catch (error) {
      toast.error(error.response.data.message)
    }
  }
}
